import { Help } from '@eggplant/embedded-documentation'
import {
  CONTROLLER,
  DASHBOARDS,
  DESIGNER,
  ENVIRONMENTS,
  HELP,
  INSIGHTS,
  LOG_OUT,
  MONITOR,
  Redirect,
  Router as RoutingRouter,
  SPACE_DETAILS,
  SYSTEM
} from '@eggplant/routing'
import '@reach/skip-nav/styles.css'
import { lazy } from 'react'
import LogOut from './GateKeeper/LogOut'

const Dashboards = lazy(() => import(/* webpackChunkName: 'Dashboards' */ './DashboardsRouter'))
const Insights = lazy(() => import(/* webpackChunkName: 'Insights' */ './InsightsRouter'))
const Designer = lazy(() => import(/* webpackChunkName: 'Designer' */ './DesignerRouter'))
const ControllerRouter = lazy(() => import(/* webpackChunkName: 'ControllerRouter' */ './ControllerRouter'))
const MonitorRouter = lazy(() => import(/* webpackChunkName: 'MonitorRouter' */ './MonitorRouter'))
const SystemRouter = lazy(() => import(/* webpackChunkName: 'SystemRouter' */ './SystemRouter'))
const Spaces = lazy(() => import(/* webpackChunkName: 'MainRouteSpace' */ '../SpaceHub/MainRouteSpace/MainRouteSpace'))
const Environments = lazy(() => import(/* webpackChunkName: 'MainRouteEnvironments' */ '../SpaceEnvironments/MainRouteEnvironments'))

const WILDCARD = '/*'

const MainDaiRoute = () => (
  <RoutingRouter isFlex>
    <Redirect
      // @ts-expect-error
      path='/'
      to={DASHBOARDS}
    />
    <Spaces
      // @ts-expect-error
      path={SPACE_DETAILS + '/:spaceId' + WILDCARD}
    />
    <Environments
      // @ts-expect-error
      path={ENVIRONMENTS + WILDCARD}
    />
    <Dashboards
      // @ts-expect-error
      path={DASHBOARDS + WILDCARD}
    />
    <Insights path={INSIGHTS + WILDCARD} />
    <Designer path={DESIGNER + WILDCARD} />
    <ControllerRouter path={CONTROLLER + WILDCARD} />
    <MonitorRouter path={MONITOR + WILDCARD} />
    <SystemRouter path={SYSTEM + WILDCARD} />
    <Help
      // @ts-expect-error
      path={HELP}
    />
    <LogOut
      // @ts-expect-error
      path={LOG_OUT}
    />
  </RoutingRouter>
)

export default MainDaiRoute
